import { LogoWhiteOnBlack } from "../icons";
import NavOrExternalLink from "../shared/NavOrExternalLink";

type SearchCardProps = {
  onClick?: () => void;
  content: any;
};

export default function AllSearchResultsCard({
  onClick,
  content,
}: SearchCardProps) {
  const expertImage =
    content.image?.fields?.image?.fields.file.url ??
    content.image?.fields?.frontifyImage[0].src ??
    null;
  const pageImage =
    content.openGraphImageUrl ?? content.opengraphFrontifyImageUrl ?? null;

  return (
    <div
      data-content-type="allSearchResultsCard"
      data-module-title={content.title ?? content.fullName}
      className="global-grid items-top w-full border-t-[1px] border-none border-black pb-10 last:border-b-[1px] lg:border-solid lg:py-10"
    >
      {/* Thumbnail and heading card */}
      <div className="lg:global-grid relative col-span-full flex lg:items-center">
        {(content.contentType === "expert" && expertImage) ||
        (content.contentType === "page" && pageImage) ? (
          <img
            className="max-h-[119px] w-[90px] object-cover object-center duration-1000 lg:col-span-2 lg:aspect-[16_/_9] lg:w-full lg:group-hover:scale-105"
            src={expertImage ?? pageImage}
            alt={content.title ?? content.fullName}
          />
        ) : (
          <div
            className={
              "flex aspect-[9/16] max-h-[119px] w-[90px] flex-shrink-0 items-center justify-center bg-slate object-cover object-center duration-1000 lg:col-span-2 lg:aspect-[16_/_9] lg:w-full lg:group-hover:scale-105"
            }
          >
            {content.contentType === "expert" ? (
              <div className="h3 uppercase text-black">
                {content.firstName.charAt(0)}
                {content.lastName.charAt(0)}
              </div>
            ) : (
              <LogoWhiteOnBlack className="sm:h-[50px] sm:w-[50px]" />
            )}
          </div>
        )}

        <NavOrExternalLink
          onClick={onClick}
          to={
            content.contentType === "expert"
              ? `/experts/${content.slug}`
              : content.slug
          }
          className="col-[2_/_-1] ml-4 before:absolute before:inset-0 before:content-[''] lg:col-[4_/_10] lg:ml-0"
        >
          <h3 className="h5 lg:h3 mb-4">{content.fullName ?? content.title}</h3>
          <p className="meta text-tertiary_text">
            {content.role ?? content.description}
          </p>
          {content.contentType === "expert" && content.type === "guest" && (
            <span className="meta lg:meta-large mt-3 block w-fit rounded-[6px] bg-black px-5 py-3 text-white lg:mt-4">
              guest author
            </span>
          )}
          {content.contentType === "expert" && content.type === "alumni" && (
            <span className="meta lg:meta-large mt-3 block w-fit rounded-[6px] border border-black bg-white p-2 text-black lg:mt-4">
              institute alumni
            </span>
          )}
        </NavOrExternalLink>
      </div>
    </div>
  );
}
